import PageContent from "./PageContent";

export default PageContent